module.exports = __webpack_public_path__ + "img/desktop.6b86cba1.png";